import { render, staticRenderFns } from "./SpecialistCollapse.vue?vue&type=template&id=091a5504"
import script from "./SpecialistCollapse.vue?vue&type=script&lang=js"
export * from "./SpecialistCollapse.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports